<app-base-wish-list id="app-base-wish-list"></app-base-wish-list>
